import { date } from "src/app/institute/interfaces/data";
import { Injectable } from "@angular/core";
import { BehaviorSubject, interval } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class TimerService {
  private startTimeGlobal: number = Date.now();
  startTime: number = this.startTimeGlobal;
  private elapsedTimeSubjectGlobal = new BehaviorSubject<string>("");
  private elapsedTimeSubject = new BehaviorSubject<string>("");
  ispaused = new BehaviorSubject<boolean>(false);
  elapsedTime$ = this.elapsedTimeSubject.asObservable();
  elapsedTimeGlobal$ = this.elapsedTimeSubjectGlobal.asObservable();
  constructor() {
    interval(1000).subscribe(() => {
      if (this.ispaused.value) return;
      const elapsedGlobal = Math.floor(
        (Date.now() - this.startTimeGlobal) / 1000
      );
      this.elapsedTimeSubjectGlobal.next(this.formatTime(elapsedGlobal));
      const elapsed = Math.floor((Date.now() - this.startTime) / 1000);
      this.elapsedTimeSubject.next(this.formatTime(elapsed));
    });
  }

  initTimerGlobal(date: string) {
    const totalSeconds = this.parseTimeToSeconds(date);
    this.startTimeGlobal = Date.now() - totalSeconds * 1000;
  }

  initTimer(timeString: string) {
    const totalSeconds = this.parseTimeToSeconds(timeString);
    this.startTime = Date.now() - totalSeconds * 1000; // Ajustar startTime correctamente
  }

  formatTime(seconds: number): string {
    const h = Math.floor(seconds / 3600)
      .toString()
      .padStart(2, "0");
    const m = Math.floor((seconds % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${h}:${m}:${s}`;
  }

  private parseTimeToSeconds(time: string): number {
    const [h, m, s] = time.split(":").map(Number);
    return (h || 0) * 3600 + (m || 0) * 60 + (s || 0);
  }
}
